export enum ContactsActionTypes {
  API_RESPONSE_SUCCESS = "@@contacts/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@contacts/API_RESPONSE_ERROR",

  GET_CONTACTS = "@@contacts/GET_CONTACTS",
  GET_CONTACTS_PAGE = "@@contacts/GET_CONTACTS_PAGE",
  RESET_CONTACTS = "@@contacts/RESET_CONTACTS",
  INVITE_CONTACT = "@@contacts/INVITE_CONTACT",
}
export interface ContactsState {
  contacts: Array<any>;
  // pagination
  contactsPage: number;
  contactsTotal: number;
  contactsHasMore: boolean;
  contactsPageLoading: boolean;
}
